{
    "locale": "sv-SE",
    "General": {
        "OrText": "Eller",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Gå till My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Skapa nytt konto",
        "ButtonText_SignInToYourAccount": "Logga in på ditt konto",
        "ButtonText_StartInterviewWithoutSigningUp": "Starta intervju utan att skapa konto",
        "ButtonText_StartInterviewWithoutSigningIn": "Starta intervju utan att logga in",
        "Navlink_Dashboard": "Översikt",
        "Navlink_MyInterviews": "Mina intervjuer",
        "Navlink_LearnWithHubert": "Lär dig med Hubert",
        "Navlink_HelpCenter": "Hjälpcenter",
        "MyProfile": "Min profil",
        "LogOut": "Logga ut"
    },
    "Login": {
        "MainTitle": "Vill du se resultatet av din Hubert-intervju?",
        "Subtitle": "Logga in för att se dina resultat, få feedback, läsa råd och mycket mer.",
        "LoginTitle": "Logga in på ditt Hubert-konto",
        "Label_Email": "E-post",
        "Label_Password": "Lösenord",
        "ButtonText_SignIn": "Logga in",
        "ButtonText_ForgotPassword": "Glömt lösenord?",
        "ButtonText_ContinueWithGoogle": "Fortsätt med Google",
        "OrSeparator": "Eller",
        "Error_Email_Required": "E-post krävs.",
        "Error_Email_Invalid": "Ange en giltig e-postadress.",
        "Error_Password_Required": "Lösenord krävs.",
        "Error_Use_Same_Email_As_Interview": "Var vänlig använd samma e-post som du angav under intervjun."
    },
    "Registration": {
        "MainTitle": "Vill du se resultatet från din Hubert-intervju?",
        "Subtitle": "Registrera dig för att se dina resultat, få feedback, läsa råd och mycket mer.",
        "RegistrationTitle": "Skapa ett Hubert-konto",
        "BenefitsBox_Title": "Du kan",
        "BenefitsBox_Point1": "Få tillgång till din intervjuhistorik",
        "BenefitsBox_Point2": "Få feedback på dina intervjuer",
        "BenefitsBox_Point3": "Återanvända svar i nya intervjuer",
        "BenefitsBox_Point4": "Få intervjuråd",
        "BenefitsBox_Point5": "Läsa karriärguider",
        "BenefitsBox_Point6": "Och mycket mer",
        "Label_FirstName": "Förnamn",
        "Label_LastName": "Efternamn",
        "Label_Email": "E-post",
        "Label_Password": "Lösenord",
        "Label_PhoneNumber": "Telefonnummer",
        "Label_TermsOfService": "Jag accepterar",
        "Label_TermsOfServiceLink": "integritetspolicy och de allmänna villkoren",
        "Placeholder_CountryCode": "Välj landskod",
        "Placeholder_PhoneNumber": "T.ex. 0701234567",
        "HelpText_Password": "Lösenordet måste vara minst 6 tecken långt.",
        "ButtonText_SignUp": "Registrera dig",
        "ButtonText_SignUpWithGoogle": "Registrera dig med Google",
        "OrSeparator": "Eller",
        "Error_FirstName_Required": "Förnamn krävs.",
        "Error_LastName_Required": "Efternamn krävs.",
        "Error_Email_Required": "E-post krävs.",
        "Error_Email_Invalid": "Ange en giltig e-postadress.",
        "Error_Email_Exists": "E-posten används redan.",
        "Error_Password_Required": "Lösenord krävs.",
        "Error_Password_6_Characters": "Ditt lösenord måste vara minst 6 tecken långt.",
        "Error_PhoneNumber_Required": "Telefonnummer krävs.",
        "Error_PhoneNumber_Invalid": "Telefonnumret är inte giltigt.",
        "Error_PrivacyPolicyCheck_Required": "integritetspolicy och de allmänna villkoren måste accepteras."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "För att göra intervjun, måste du acceptera de allmänna villkoren för att använda Hubert. Kryssa bara i rutan för att fortsätta.",
        "Subtitle_AfterInterviewCompleted": "Registrera dig för att se dina resultat, få feedback, läsa råd och mycket mer.",
        "PrivacyPolicyText": "Genom att trycka på registrera dig godkänner du",
        "PrivacyPolicyLink": "integritetspolicy och de allmänna villkoren",
        "ButtonText_SignUp": "Skapa konto och gå till intervjun",
        "ButtonText_SignUpNormal": "Skapa konto",
        "ButtonText_SignInInstead": "Klicka här för att logga in istället"
    },
    "LoginInviteEmail": {
        "Subtitle": "Logga in för att se dina resultat, få feedback, läsa råd och mycket mer."
    },
    "AppMessages": {
        "internal-server-error": "Ett oväntat fel uppstod.",
        "invalid-credentials": "Ogiltiga uppgifter. Var god försök igen.",
        "user-not-found": "Ogiltiga uppgifter. Var god försök igen.",
        "account-not-found": "Ogiltigt konto. Var god försök igen.",
        "verify-email-title": "Verifiera din e-post",
        "verify-email-subtitle": "Kolla din e-post för att verifiera ditt konto.",
        "email-not-verified-title": "E-post inte verifierad",
        "email-not-verified-subtitle": "Kolla din e-post för att verifiera ditt konto.",
        "verifying-email-title": "Verifierar e-post",
        "verifying-email-subtitle": "Vänligen vänta...",
        "sign-in-title": "Loggar in",
        "sign-in-subtitle": "Vänligen vänta...",
        "server-error": "Något gick fel.",
        "hubert-user-exists": "Kontot finns redan.",
        "account-exists": "Kontot finns redan.",
        "email-verified": "Din e-postadress har verifierats.",
        "email-is-taken": "E-posten används redan.",
        "re-enter-password": "Använd ditt lösenord för att logga in",
        "password-reset": "Ditt lösenord har ändrats.",
        "re-enter-new-password": "Använd ditt nya lösenord för att logga in",
        "invalid-invitation": "Ogiltig inbjudan.",
        "invalid-code": "Ogiltig verifikationskod.",
        "email-already-verified": "Din e-postadress är redan verifierad.",
        "email-mismatch-title": "E-postadressen stämmer inte",
        "email-mismatch-subtitle": "Vänligen använd samma e-postadress som du använde för att söka jobbet."
    },
    "TransitionPage": {
        "loading-title": "Laddar...",
        "loading-subtitle": "Förbereder dina uppgifter...",
        "logout-title": "Laddar...",
        "logout-subtitle": "Du loggas ut..."
    },
    "ImpersonationPage": {
        "loading-title": "Laddar...",
        "loading-subtitle": "Förbereder dina uppgifter..."
    },
    "ProcessInvitation": {
        "loading-title": "Laddar...",
        "loading-subtitle": "Vänta medan vi laddar din intervju.",
        "InvitationNotFound": "Vi kan inte hitta din intervju.",
        "InvitationExpired": "Länken till intervjun har gått ut.",
        "InvitationExpired_Description1": "Öppna intervjun från",
        "InvitationExpired_Description2": "eller kontakta din rekryterare.",
        "InvitationInvalid": "Länken till denna inbjudan är ogiltig.",
        "InterviewCompleted": "Denna intervju har redan genomförts."
    },
    "Common": {
        "MyInterviews": {
            "Title": "Mina intervjuer",
            "TableHead_Employer": "Arbetsgivare",
            "TableHead_Job": "Jobb",
            "TableHead_Status": "Status",
            "TableHead_ApplicationDate": "Ansökningsdatum",
            "TableBody_StartInterview": "Intervjun är inte avslutad. Klicka här för att starta eller återuppta intervjun.",
            "TableBody_NotScored": "Intervjun är avslutad. Resultatet kommer inom kort.",
            "TableBody_Details": "Klicka här för att se intervjuresultat och mer.",
            "ApplicationDate_Invited": "Inbjuden",
            "ApplicationDate_MinuteAgo": "minut sedan",
            "ApplicationDate_MinutesAgo": "minuter sedan",
            "ApplicationDate_HourAgo": "timme sedan",
            "ApplicationDate_HoursAgo": "timmar sedan",
            "ApplicationDate_DayAgo": "dag sedan",
            "ApplicationDate_DaysAgo": "dagar sedan",
            "ButtonText_SeeAllInterviews": "Se alla intervjuer",
            "ButtonText_Details": "Detaljer",
            "ButtonText_StartInterview": "Gå till intervju",
            "ButtonText_NotScored": "Inväntar resultat",
            "NoInterviews_Message": "Det finns inga tidigare eller kommande intervjuer för dig."
        },
        "LatestJobPostings": {
            "NoJobPostings": "Det finns inga jobbannonser för tillfället. Vänligen kolla igen senare."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "Min karriär",
            "Subtitle": "Klicka på intervjun för att se bedömningen och dina utsikter.",
            "MostRecentInterview": "Senaste intervjun",
            "ToDo": "Att göra",
            "NoOngoingInterviews_Title": "Inga nya intervjuinbjudningar.",
            "NoOngoingInterviews_Subtitle": "Nya Hubert-intervjuer dyker upp här när de schemalagts av rekryterare.",
            "NoRecentInterviews_Title": "Inga tidigare intervjuer hittades.",
            "NoRecentInterviews_Subtitle": "När du bjuds in till en intervju visas den här nedanför.",
            "ButtonText_StartInterview": "Gå till intervju",
            "ButtonText_NotScored": "Väntande resultat",
            "ButtonText_Details": "Detaljer"
        },
        "LearnWithHubert": {
            "Title": "Lär dig med Hubert",
            "Subtitle": "Få råd om hur du förbättrar dina intervjufärdigheter och presterar bättre på jobbet.",
            "PickedForMe": "Senaste artiklarna",
            "ButtonText_SeeAllArticles": "Se alla artiklar"
        },
        "HubertTip": {
            "Title": "Hubert-tips",
            "Subtitle": "Genomför intervjuer snabbare",
            "Description": "Söker du ett nytt jobb i en liknande roll som du tidigare gjort en Hubert-intervju för? Du kan återanvända dina svar och spara tid.",
            "ButtonText_ReadMoreTips": "Läs fler tips"
        },
        "NewCandidateModalPopup": {
            "Title": "Allt är klart!",
            "DescriptionLine1": "Ditt konto är nu redo.",
            "DescriptionLine2": "Hantera dina intervjuer och profil. Se resultat, få feedback och lär dig mer om intervjuer.",
            "ButtonText_LetsGo": "Nu kör vi"
        },
        "InterviewCompletedModal": {
            "Title": "Bra jobbat!",
            "Subtitle": "Du har slutfört din intervju.",
            "Description": "Rekryterare kommer att granska alla ansökningar och ge återkoppling via e-post eller telefon så snart de har en uppdatering.",
            "ButtonText_Continue": "Fortsätt"
        },
        "LatestJobPostings": {
            "Title": "Senaste jobbannonserna",
            "Subtitle": "Utforska andra erbjudanden från Huberts partners som nyligen publicerades."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "Mina intervjuer",
        "MyInterviewsSection_Subtitle": "Klicka på intervjun för att se bedömningen och dina karriärmöjligheter.",
        "MyInterviewsSection_ToDo": "Att göra"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Se alla intervjuer",
        "InterviewNotFound_Title": "Intervju ej tillgänglig",
        "InterviewNotFound_Description": "Du försöker komma åt intervjudetaljer som inte är kopplade till ditt konto.",
        "ButtonText_GoToAllInterviews": "Gå till Mina intervjuer",
        "InterviewDetails": {
            "Title": "Intervjudetaljer",
            "ForRole": "För rollen",
            "InterviewCompletedOn": "Intervjun slutförd {{date}} klockan {{time}}"
        },
        "MyResult": {
            "Title": "Mitt resultat",
            "Subtitle": "Bedömd matchning",
            "ButtonText_LearnMore": "Lär dig hur dina svar bedöms",
            "GotPotential_Title": "Stark potential, ett krav saknas",
            "GotPotential_Description": "Dina svar visar stark potential för denna typ av roll. Baserat på denna intervju kanske du dock inte uppfyller en eller flera kvalifikationer som krävs för just detta jobb. Det kan påverka nästa steg, beroende på rekryterarens behov och övriga kandidater. Om du inte går vidare till nästa steg, kom ihåg att det inte nödvändigtvis speglar din potential. Ofta handlar det om att hitta en exakt matchning för rollens specifika behov. Kolla in andra möjligheter och tips nedan.",
            "GotPotential_DescriptionSecondary": "Huberts bedömning är rådgivande. Rekryteraren fattar det slutgiltiga beslutet, och andra faktorer, som antalet kandidater, kan också påverka resultatet.",
            "GreatMatch_Title": "Stark matchning",
            "GreatMatch_Description": "Dina svar stämde väl överens med vad rekryterare vanligtvis söker för denna roll, och du uppfyller kraven. Utmärkt arbete. Rekryteraren kommer att granska alla kandidater och besluta om nästa steg.",
            "GreatMatch_DescriptionSecondary": "Huberts bedömning är rådgivande. Rekryteraren fattar det slutgiltiga beslutet, och andra faktorer, som antalet kandidater, kan också påverka resultatet. Om du inte går vidare till nästa steg, kom ihåg att det inte nödvändigtvis speglar din potential. Ofta handlar det om att hitta en exakt matchning för rollens specifika behov. Kolla in andra möjligheter och tips nedan.",
            "OkMatch_Title": "Kvalificerad, öka tydligheten",
            "OkMatch_Description": "Du uppfyller kraven för jobbet. För att sticka ut ytterligare kan dina svar behöva lite mer tydlighet och specificitet jämfört med vad rekryterare vanligtvis ser för denna roll. Granska dina svar nedan för att se var ett konkret exempel eller resultat kan höja ditt betyg.",
            "OkMatch_DescriptionSecondary": "Huberts bedömning är rådgivande. Rekryteraren fattar det slutgiltiga beslutet, och andra faktorer, som antalet kandidater, kan också påverka resultatet.",
            "NotClearMatch_Title": "Kanske inte rätt matchning just nu",
            "NotClearMatch_Description": "Baserat på denna intervju kan dina svar vara mindre i linje med vad rekryteraren söker, eller så kanske du inte uppfyller ett eller flera krav. Om du vill förbättra dig, börja med frågorna nedan. Små ändringar, mer konkretion och tydliga resultat kan göra stor skillnad nästa gång.",
            "NotClearMatch_DescriptionSecondary": "Huberts bedömning är rådgivande. Rekryteraren fattar det slutgiltiga beslutet, och andra faktorer, som antalet kandidater, kan också påverka resultatet."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Yrkeserfarenheter, motivationer och kompetenser",
            "QualifyingRequirements": "Kvalificerande krav för detta specifika jobb",
            "NotQualified_Title": "Utrymme för förbättring",
            "NotQualified_Description": "Dina svar kan ha uppfattats som mindre specifika eller resultatinriktade än vad rekryteraren förväntar sig. Titta nedan på markerade ställen där ett konkret exempel, åtgärder du vidtog eller ett tydligt resultat kan stärka dina svar.",
            "GreatResults_Title": "Starka svar",
            "GreatResults_Description": "Dina svar indikerar att du passar bra för denna typ av roll och kommunicerade tydligt. Om någon fråga kan förbättras ser du den markerad nedan.",
            "MeetingRequirements_Title": "Uppfyller kraven",
            "MeetingRequirements_Description": "Dina svar indikerar att du uppfyller de kvalificerande kraven som rekryteraren ställt för detta jobb. En bra grund.",
            "NotAllExpectationsMet_Title": "Ett eller flera krav saknas",
            "NotAllExpectationsMet_Description": "Baserat på dina svar kanske du inte uppfyller ett eller flera av de kvalificerande kraven för detta specifika jobb, såsom certifikat, licenser, utbildningsnivå eller års erfarenhet.",
            "ButtonText_FindOutPossibleReasons": "Visa detaljer"
        },
        "ScriptFromInterview": {
            "Title": "Läs hela intervjun",
            "ButtonText_SeeWholeTranscript": "Läs intervju",
            "ButtonText_DeleteInterview": "Ta bort intervju",
            "Loading_Title": "Laddar...",
            "Loading_Subtitle": "Vänta medan vi laddar din intervjuutskrift."
        },
        "HowToImproveAtInterviews": {
            "Title": "Hur du förbättrar dina intervjuer",
            "Subtitle_Questions": "Här är några frågor där ditt svar potentiellt kan förbättras.",
            "Subtitle_NoQuestions": "Inga enskilda svar markerades. Här är tips för att göra krav, exempel och resultat tydligare för den här rollen.",
            "GreatMatch_Questions_Description": "Även som en stark matchning kan vissa svar stärkas. Om vi identifierade några hittar du dem nedan. Följ instruktionerna före varje fråga. När du beskriver en situation, inkludera situationen, vad du gjorde och resultatet. Undvik mycket korta svar. Sikta på tydliga och konkreta beskrivningar, precis som i en fysisk intervju.",
            "GreatMatch_NoQuestions_Description": "Du presterade bra på dina frågor. Utmärkt arbete.",
            "OkMatch_Questions_Description": "Nedan hittar du frågor där ditt svar kan förbättras. Följ instruktionerna före varje fråga. När du beskriver en situation, inkludera situationen, vad du gjorde och resultatet. Undvik mycket korta svar. Sikta på tydliga och konkreta beskrivningar, precis som i en fysisk intervju.",
            "OkMatch_NoQuestions_Description": "Dina svar var solida, men denna roll kan vara konkurrensutsatt. Det innebär att även bra svar kan hamna i mitten.",
            "OkMatch_NoQuestions_DescriptionSecondary": "Nästa gång, fokusera på tydlighet. Börja med resultatet, lägg till ett verkligt exempel och håll det kort. Var specifik om vad du gjorde, hur du gjorde det och vad som förändrades tack vare det.",
            "GotPotential_Questions_Description": "Även om du verkar vara en stark kandidat för denna typ av jobb, kan vissa svar stärkas. Om vi identifierade några hittar du dem nedan. Följ instruktionerna före varje fråga. När du beskriver en situation, inkludera situationen, vad du gjorde och resultatet. Undvik mycket korta svar. Sikta på tydliga och konkreta beskrivningar, precis som i en fysisk intervju.",
            "GotPotential_NoQuestions_Description": "Vi hittade inga svar som behöver större förbättringar gällande professionella kompetenser och motivation. Du verkar ha svarat bra på dessa ämnen.",
            "NotClearMatch_Questions_Description": "Nedan hittar du frågor där ditt svar kan förbättras. Följ instruktionerna före varje fråga. När du beskriver en situation, inkludera situationen, vad du gjorde och resultatet. Undvik mycket korta svar. Sikta på tydliga och konkreta beskrivningar, precis som i en fysisk intervju.",
            "NotClearMatch_NoQuestions_Description": "Vi hittade inte ett enda \"dåligt\" svar. Det handlar mer om den övergripande anpassningen till vad rollen kräver. Om konkurrensen är stark kan små luckor spela roll.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "För din nästa intervju, fokusera på att vara konkret. Välj ett exempel per fråga, förklara dina handlingar och dela resultatet. Kort och specifikt slår oftast långt och generellt.",
            "Alert_WantMoreAdvice": "Vill du ha fler råd om hur du presterar bra i en Hubert-intervju?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Utforska vår artikel med allmänna råd"
        },
        "SimilarOffers": {
            "Title": "Liknande erbjudanden"
        },
        "HowHubertScoresInterviews": {
            "Title": "Hur bedömer Hubert intervjuer?",
            "Description": "Nedan följer en kort beskrivning av hur Hubert bedömer intervjusvar. Vi har också lagt till ett avsnitt om rekryteringsprocessen för att förklara nästa steg.",
            "Tabs_PossibleOutcomes": "Möjliga utfall",
            "Tabs_RecruitmentProcess": "Rekryteringsprocess",
            "AssessedMatch_Title": "Bedömd matchning",
            "AssessedMatch_Description": "Hubert bedömer hur dina svar överlag stämmer överens med vad rekryterare vanligtvis söker för denna roll. Tillsammans med rollkraven ser du ett av resultaten nedan.",
            "AssessedMatch_DescriptionSecondary": "Huberts bedömning är rådgivande. Rekryteraren fattar det slutgiltiga beslutet, och andra faktorer, som antalet kandidater, kan också påverka resultatet.",
            "GreatMatch_Title": "Stark matchning",
            "GreatMatch_Description": "Dina svar stämde väl överens med vad rekryterare söker, och du uppfyller kraven. Utmärkt arbete. Rekryteraren kommer att granska kandidaterna och besluta om nästa steg.",
            "GotPotential_Title": "Stark potential, ett krav saknas",
            "GotPotential_Description": "Dina svar indikerar stark potential. Men baserat på denna intervju kanske du inte uppfyller ett eller flera krav. Detta kan påverka nästa steg, beroende på rekryterarens behov.",
            "OkMatch_Title": "Kvalificerad, öka tydligheten",
            "OkMatch_Description": "Du uppfyller kraven. För att sticka ut kan dina svar behöva mer tydlighet och specificitet. Använd feedbacken i din intervju för att stärka dina exempel i framtiden.",
            "NotClearMatch_Title": "Kanske inte rätt matchning just nu",
            "NotClearMatch_Description": "Baserat på denna intervju kan dina svar vara mindre i linje med vad rekryteraren söker, och du kanske inte uppfyller vissa krav. Granska dina svar för att se var du kan lägga till tydlighet och exempel.",
            "ProfessionalExperiences_Title": "Yrkeserfarenheter, motivationer och kompetenser",
            "ProfessionalExperiences_Description": "Detta är frågor om dina tidigare erfarenheter, din motivation och relevanta kompetenser. Rekryterare bestämmer vilka frågor som används.",
            "GreatResults_Title": "Starka svar",
            "GreatResults_Description": "Dina svar indikerar att du passar bra för denna typ av roll och kommunicerade tydligt. Om någon fråga kan förbättras ser du den markerad.",
            "NotQualified_Title": "Utrymme för förbättring",
            "NotQualified_Description": "Dina svar kan ha varit mindre specifika eller resultatinriktade än förväntat. Leta efter markerade ställen där ett konkret exempel eller tydligt resultat kan stärka dina svar.",
            "QualifyingRequirements_Title": "Grundläggande eller kvalificerande krav",
            "QualifyingRequirements_Description": "Dessa är frågor som rekryteraren har ställt som krav, till exempel ett certifikat, körkort eller en viss nivå av erfarenhet.",
            "MeetingRequirements_Title": "Uppfyller kraven",
            "MeetingRequirements_Description": "Dina svar indikerar att du uppfyller de kvalificerande kraven. En bra grund.",
            "NotAllExpectationsMet_Title": "Ett eller flera krav saknas",
            "NotAllExpectationsMet_Description": "Baserat på dina svar kanske du inte uppfyller ett eller flera kvalificerande krav för detta specifika jobb.",
            "RecruitmentProcess_Title": "Rekryteringsprocess",
            "RecruitmentProcess_Description": "Hubert används ofta som ett första steg i en rekryteringsprocess med många kandidater. Det gör det möjligt för alla att genomföra en intervju och dela mer om sig själva. Eftersom frågorna är desamma för alla är processen mer konsekvent. Hubert använder inte information som ålder, kön eller utseende, vilket minskar risken för omedveten partiskhet.",
            "EventOne_Title": "Du intervjuas av Hubert",
            "EventOne_Description": "Du gör intervjun när och var det passar dig. Det finns inga tidsbegränsningar och du kan pausa när som helst.",
            "EventTwo_Title": "Din intervju bedöms",
            "EventTwo_Description": "Hubert bedömer dina svar med modern teknik. Så snart bedömningen är klar syns resultaten här i My Hubert och för rekryteraren.",
            "EventThree_Title": "Rekryteraren väljer kandidater",
            "EventThree_Description": "Rekryterare ser när ett nytt resultat är tillgängligt. De granskar dina svar och Huberts bedömning. Baserat på den rådgivande bedömningen och deras eget omdöme beslutar de om du ska bjudas in till nästa steg (samtal, test, slutintervju). Om andra kandidater passar bättre kan din ansökan avslås.",
            "ButtonText_Close": "Stäng"
        }
    },
    "MyProfile": {
        "Title": "Min profil",
        "MyDetails": {
            "Title": "Mina uppgifter",
            "Label_FirstName": "Förnamn",
            "Label_LastName": "Efternamn",
            "Label_Email": "E-post",
            "Label_PhoneNumber": "Telefonnummer",
            "ButtonText_UpdateDetails": "Uppdatera uppgifter",
            "Error_FirstName_Required": "Förnamn krävs.",
            "Error_LastName_Required": "Efternamn krävs.",
            "Error_Email_Required": "E-post krävs.",
            "Error_Email_Invalid": "Ange en giltig e-postadress.",
            "Error_PhoneNumber_Invalid": "Telefonnumret är inte giltigt.",
            "Success_Details_Updated": "Profilen uppdaterad."
        },
        "ChangePassword": {
            "Title": "Byt lösenord",
            "Set_Password_Title": "Skapa lösenord",
            "Label_CurrentPassword": "Nuvarande lösenord",
            "Label_NewPassword": "Nytt lösenord",
            "Label_RepeatNewPassword": "Upprepa nytt lösenord",
            "Alert_SignInAgain": "Vänligen logga in igen för att ställa in ditt lösenord.",
            "ButtonText_UpdatePassword": "Uppdatera lösenord",
            "ButtonText_SetPassword": "Ställ in lösenord",
            "ButtonText_SignInAgain": "Logga in igen",
            "Error_CurrentPassword_Required": "Nuvarande lösenord krävs.",
            "Error_CurrentPassword_DoesntMatch": "Lösenordet matchar inte nuvarande lösenord.",
            "Error_NewPassword_Required": "Nytt lösenord krävs.",
            "Error_NewPassword_6_Characters": "Ditt nya lösenord måste vara minst 6 tecken långt.",
            "Error_RepeatNewPassword_Required": "Upprepat nytt lösenord krävs.",
            "Error_RepeatNewPassword_DoesntMatch": "Lösenordet matchar inte det nya lösenordet.",
            "Success_Password_Changed": "Lösenordet uppdaterat.",
            "Error_Invalid_CurrentPassword": "Ogiltigt nuvarande lösenord."
        },
        "NotificationPreferences": {
            "Title": "Aviseringsinställningar",
            "Label_ReceiveUpdatesToggle": "Jag vill ta emot uppdateringar från Hubert.",
            "Label_ReceiveUpdatesToggleHelpText": "Du kommer att få karriärguider, intervjutips och mer."
        },
        "AccountRemoval": {
            "Title": "Ta bort konto",
            "ButtonText_RemoveMyAccount": "Ta bort mitt konto"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Hej",
        "Subtitle": "Du ska precis starta din jobbintervju.",
        "TipBox_Title": "Här är några tips som kan hjälpa dig.",
        "TipBox_Tip1": "Gör intervjun på en lugn plats så att du kan koncentrera dig.",
        "TipBox_Tip2": "Svara på en dator med tangentbord (om du inte är bekväm med att skriva mycket på mobilen).",
        "TipBox_Tip3": "Var så specifik och detaljerad som möjligt. Hubert och rekryterarna vill lära känna dig väl.",
        "TipBox_Tip4": "Ta den tid du behöver. Det finns inga tidsbegränsningar.",
        "TipBox_Tip5": "Du kan ta en paus när som helst och fortsätta där du slutade.",
        "TipBox_Tip6": "Var dig själv och ta Hubert-intervjun lika seriöst som en riktig intervju.",
        "CheckAdviceArticle_Text1": "Om du vill ha fler tips om hur du lyckas på intervjun, kolla in denna",
        "CheckAdviceArticle_Text2": "artikel",
        "CheckAdviceArticle_Text3": "med bra råd.",
        "ReadyToGetStarted": "Är du redo att börja?",
        "ORSeparator_Text": "Eller",
        "ButtonText_StartInterviewNow": "Starta intervjun nu",
        "ButtonText_SetReminder": "Inte redo, ställ in påminnelse",
        "PrivacyPolicyText": "Genom att trycka på starta intervju godkänner du",
        "PrivacyPolicyLink": "integritetspolicy och de allmänna villkoren"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Bra jobbat!",
        "CompletedAlert_Subtitle": "Du har slutfört din intervju.",
        "CompletedAlert_Description": "Rekryterare kommer att granska alla ansökningar och ge återkoppling via e-post eller telefon så snart de har en uppdatering.",
        "InterviewNotCompleted": "Denna intervju är inte slutförd."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Hjälpcenter",
            "Subtitle": "Hitta svar på de vanligaste frågorna om Hubert.",
            "Label_Search": "sök vanliga frågor",
            "ButtonText_Search": "Sök"
        },
        "FAQSection": {
            "Tabs_All": "Alla",
            "Tabs_AboutHubertInterview": "Om Hubert-intervjun",
            "Tabs_TechnicalSupport": "Teknisk support"
        },
        "StillHaveQuestion": {
            "Title": "Har du fortfarande en fråga?",
            "Description": "Vi hjälper gärna till.",
            "DropUsAEmail": "Mejla oss på hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Kan jag genomföra min intervju via telefonsamtal istället?",
                    "a": "Hubert fungerar för närvarande endast via chatt. Om du har ett medicinskt tillstånd som förhindrar dig från att göra intervjun, vänligen kontakta det anställande företaget direkt."
                },
                {
                    "q": "Kan jag göra intervjun på ett annat språk?",
                    "a": "För vissa intervjuer finns det möjlighet att välja språk i början. Om detta alternativ saknas är språket troligen ett krav för tjänsten. Kontakta rekryterande företag för frågor."
                },
                {
                    "q": "Blir jag straffad för korta svar?",
                    "a": "Nej, så länge du svarar på frågorna på ett lämpligt sätt. Detaljer hjälper dock ofta."
                },
                {
                    "q": "Kan jag återanvända mina svar?",
                    "a": "Ja, om du är inloggad på My Hubert och söker en liknande roll."
                },
                {
                    "q": "Kommer en människa att läsa min intervju?",
                    "a": "Ja, våra kunder uppmanas att manuellt kontrollera intervjuer."
                },
                {
                    "q": "Jag har gjort intervjun, vad händer nu?",
                    "a": "Resultaten skickas till rekryteraren. De granskar dina svar och bedömningen och beslutar om nästa steg (samtal, test, intervju)."
                },
                {
                    "q": "Jag har en fråga om nästa steg, vem ska jag kontakta?",
                    "a": "Vänligen kontakta företaget du sökte jobb hos."
                },
                {
                    "q": "Hur säkerställer ni att ni inte inför bias?",
                    "a": "Hubert är konsekvent och vet inte ålder, kön eller utseende, vilket minskar risken för omedveten partiskhet."
                },
                {
                    "q": "Kan jag bli intervjuad av en människa?",
                    "a": "Kontakta företaget för att fråga om detta."
                },
                {
                    "q": "Är Hubert en människa?",
                    "a": "Nej, Hubert är ett datorbaserat system."
                },
                {
                    "q": "Kan jag ändra mina svar i efterhand?",
                    "a": "Nej, precis som i en riktig intervju kan du inte göra om svaren."
                },
                {
                    "q": "Hur lyckas jag i Hubert-intervjun?",
                    "a": "Läs frågorna noga, följ instruktionerna, ge riktiga exempel och var ärlig."
                },
                {
                    "q": "Jag behöver ett jobb, vem ska jag kontakta?",
                    "a": "Kontakta företaget du sökte hos."
                },
                {
                    "q": "Jag har inte hört något efter intervjun. Vad ska jag göra?",
                    "a": "Rekryterare beslutar om nästa steg. Om andra kandidater passar bättre kan ansökan avslås. Du kan kontakta rekryteraren för uppdatering."
                },
                {
                    "q": "Jag har erfarenhet men fick inte jobbet. Varför?",
                    "a": "Konkurrensen kan vara hård. Fråga företaget varför eller kolla My Hubert för feedback."
                },
                {
                    "q": "Hur lång tid tar intervjun?",
                    "a": "Mellan 10 och 25 minuter. Stressa inte."
                },
                {
                    "q": "Var kan jag läsa om datahantering?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "Varför ser jag inte mina tidigare intervjuer?",
                    "a": "Se till att du använde samma e-postadress vid ansökan och inloggning (inklusive Google-inloggning)."
                },
                {
                    "q": "Varför fick jag inget mejl?",
                    "a": "Kolla skräpposten. Eller skapa ett My Hubert-konto med ansökningsmejlen för att hitta länken."
                },
                {
                    "q": "Jag hittar inte länken i mejlet.",
                    "a": "Kolla skräpposten. Eller logga in på My Hubert och gå till 'Mina intervjuer'."
                },
                {
                    "q": "Fungerar intervjun på mobilen?",
                    "a": "Ja, men dator kan vara bekvämare för att skriva."
                },
                {
                    "q": "Intervjun fungerar inte, vad göra?",
                    "a": "Mejla oss på hubert@hubert.ai så hjälper vi dig."
                },
                {
                    "q": "Jag vill ta bort mitt konto, vad göra?",
                    "a": "Mejla oss på hubert@hubert.ai."
                },
                {
                    "q": "Intervjun avbröts, hur kommer jag tillbaka?",
                    "a": "Klicka på länken i mejlet eller logga in på My Hubert."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Lär dig med Hubert",
            "Subtitle": "Ta reda på hur du ökar dina chanser och presterar bättre.",
            "Label_Search": "sök guider",
            "ButtonText_Search": "Sök"
        },
        "TabSelector": {
            "MyFeed": "Mitt flöde",
            "InterviewGuides": "Intervjuguider",
            "CareerGuides": "Karriärguider"
        },
        "NewestOnTheFeed": "Nyast",
        "PickedForMe": "Senaste artiklarna",
        "InterviewGuides": "Intervjuguider",
        "CareerGuides": "Karriärguider"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Tillbaka till alla artiklar"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Återställ lösenord",
        "ResetLinkAlert_Subtitle": "Klicka på länken i ditt mejl för att sätta ett nytt lösenord.",
        "PasswordNotSetAlert_Message": "Lösenord ej satt, logga in med ",
        "ResetYourPassword": {
            "MainTitle": "Se dina Hubert-resultat",
            "Subtitle": "Logga in för att se resultat, få feedback och mer.",
            "FormSectionTitle": "Återställ lösenord",
            "Label_NewPassword": "Nytt lösenord",
            "Label_ConfirmNewPassword": "Bekräfta nytt lösenord",
            "Error_NewPassword_Required": "Ange ett nytt lösenord.",
            "Error_Password_6_Characters": "Lösenordet måste vara minst 6 tecken.",
            "Error_ConfirmNewPassword_Required": "Bekräfta ditt lösenord.",
            "Error_ConfirmNewPassword_NotMatch": "Lösenorden matchar inte.",
            "Error_MalformedResetUrl": "Ogiltig kod. Försök igen.",
            "Error_ResetPasswordFailed": "Problem vid återställning. Försök igen.",
            "Error_WeakPassword": "Lösenordet måste ha minst 6 tecken.",
            "Error_InvalidCode_Title": "Förfrågan har löpt ut eller är ogiltig.",
            "Error_InvalidCode_Subtitle": "Försök återställa lösenordet igen.",
            "ButtonText_SetNewPassword": "Sätt lösenord & logga in",
            "ButtonText_RememberYourPassword": "Kommer du ihåg lösenordet?",
            "ButtonText_SignInInstead": "Logga in istället"
        }
    },
    "PageNotFound": {
        "Title": "Sidan hittades inte",
        "Description": "Vi kan inte hitta sidan du söker.",
        "ButtonText_GoToDashboard": "Gå till Översikt",
        "ButtonText_GoToLogin": "Gå till Logga in"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "Återanvändning av svar är inte tillgängligt för denna intervju ännu. Vi förväntar oss att det blir tillgängligt snart, men du kan göra intervjun nu.",
        "DescriptionLine2": "Gå vidare till intervjun genom att klicka på knappen nedan.",
        "ButtonText_TakeMeToTheInterview": "Ta mig till intervjun"
    },
    "UnsubscribeFromEmails": {
        "Title": "Är du säker?",
        "Subtitle": "Du slutar få mejl om detta jobb:",
        "SelectTheReason": "Välj en anledning.",
        "ReasonText1": "Jag har hittat ett annat jobb.",
        "ReasonText2": "Jag är inte längre intresserad.",
        "ReasonText3": "Annat",
        "ButtonText_Unsubscribe": "Avsluta prenumeration",
        "Placeholder_YourReason": "Din anledning",
        "Success_Title": "Du har avregistrerats från mejl om detta jobb.",
        "Loading": "Laddar...",
        "Error_YourReason_Required": "Ange en anledning.",
        "Error_ServerIssue": "Avregistrering misslyckades på grund av serverfel."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Försök igen"
    },
    "Outreach": {
        "CandidateNotFound": "Kandidaten hittades inte",
        "CandidateNotFoundDesc": "Vi kunde inte hitta intervjudetaljerna du söker.",
        "InterviewEnded": "Intervjun är avslutad",
        "InterviewEndedDesc1": "Den här intervjusessionen har avslutats eller är inte längre tillgänglig.",
        "InterviewEndedDesc2": "Tack för din tid. Har du frågor? Kontakta rekryteringsteamet.",
        "ReadyTitle": "Redo för din intervju, {{firstName}}?",
        "InvitationDesc": "Hubert bjuder in dig, på uppdrag av {{companyName}}, till en chattbaserad intervju som tar cirka 1–2 minuter att genomföra.",
        "Button_StartChat": "Starta chatten",
        "CancelNotice": "Om du startar här avbokas det schemalagda samtalet för den här rollen.",
        "PreferNotToContinue": "Vill du inte fortsätta?",
        "DeclineLabel": "Jag är inte intresserad av den här rollen. Kontakta mig inte igen om den här tjänsten.",
        "Button_ConfirmAndDecline": "Bekräfta och tacka nej",
        "Processing": "Behandlar...",
        "Toast_DeclineSuccess": "Du har tackat nej till intervjun.",
        "Toast_CancelVoiceInfo": "Telefonsamtalet är avbokat. Funktionen kommer snart.",
        "Toast_CancelError": "Det gick inte att avboka intervjun. Försök igen.",
        "Footer_WithdrawConsent": "Du kan när som helst återkalla ditt samtycke. Läs mer i ",
        "Footer_PrivacyPolicySuffix": "s integritetspolicy",
        "Footer_And": " och ",
        "Footer_HubertPrivacyLink": "Huberts integritetspolicy och användarvillkor",
        "Chat_InterviewWith": "Intervju med {{companyName}}",
        "Chat_StatusConnected": "Ansluten",
        "Chat_StatusError": "Fel",
        "Chat_StatusDisconnected": "Frånkopplad",
        "Chat_StatusConnecting": "Ansluter...",
        "Chat_ReadyToStart": "Redo att starta intervjun?",
        "Chat_ButtonStart": "Starta intervjun",
        "Chat_SayHello": "Säg HEJ för att börja.",
        "Chat_EmptyState": "Skicka ett meddelande för att börja.",
        "Chat_SelectLanguage": "Välj språk",
        "Chat_Placeholder": "Skriv ditt meddelande...",
        "Chat_ButtonSend": "Skicka",
        "Chat_ButtonBack": "Tillbaka",
        "LoadingCandidateDetails": "Laddar kandidatdetaljer...",
        "FetchingCandidateDetails": "Hämtar kandidatdetaljer...",
        "Chat_StatusReady": "Väntar på att ansluta...",
        "Chat_ForbiddenError": "Den här chattintervjun är inte längre tillgänglig.",
        "Chat_GeneralError": "Det gick inte att starta chatten. Försök igen senare.",
        "Chat_SelectUiLanguage": "Språk i menyn",
        "Chat_InterviewTitle": "Jobbintervju"
    }
}
